export default "__VITE_ASSET__CrRHagJi__"